export const defaultScopeId = "v3.account";
export const contextKey = "account";

export const CURRENT_ACCOUNT_REQUESTED = "ACCOUNT/CURRENT_ACCOUNT_REQUESTED";
export const CURRENT_ACCOUNT_SUCCEEDED = "ACCOUNT/CURRENT_ACCOUNT_SUCCEEDED";
export const CURRENT_ACCOUNT_FAILED = "ACCOUNT/CURRENT_ACCOUNT_FAILED";

// eslint-disable-next-line complexity, max-statements
export default (
    state = {
        currentAccount: null,
        errors: [],
        hasInitialData: false,
        loading: 0,
    },
    { type, data }
) => {
    switch (type) {
    case CURRENT_ACCOUNT_REQUESTED: {
        ++state.loading;
        return state;
    }
    case CURRENT_ACCOUNT_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        state.currentAccount = data;
        return state;
    }
    case CURRENT_ACCOUNT_FAILED: {
        --state.loading;
        state.errors.push(data);
        return state;
    }
    default:
        return state;
    }
};

export const requestCurrentAccount = (data, resolve, reject) => ({ type: CURRENT_ACCOUNT_REQUESTED, data, resolve, reject });
export const succeedCurrentAccount = data => ({ type: CURRENT_ACCOUNT_SUCCEEDED, data });
export const failCurrentAccount = data => ({ type: CURRENT_ACCOUNT_FAILED, data });

